import React, { useState } from 'react';
import { Maximize2, FileDown, Image } from 'lucide-react';
import html2canvas from 'html2canvas';

const GlassCard = ({ children, className = '', title, data, chartId, extraActions }) => {
  const [isFullScreen, setIsFullScreen] = useState(false);

  const handleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setIsFullScreen(true);
    } else {
      document.exitFullscreen();
      setIsFullScreen(false);
    }
  };

  const downloadCSV = (data, filename) => {
    if (!data || data.length === 0) return;
    const headers = Object.keys(data[0]);
    const csvRows = [];
    csvRows.push(headers.join(','));
    data.forEach(row => {
      const values = headers.map(header => {
        const value = row[header];
        if (value === null || value === undefined) return '';
        if (typeof value === 'object' && value !== null) return `"${JSON.stringify(value).replace(/"/g, '""')}"`;
        if (typeof value === 'string') return `"${value.replace(/"/g, '""')}"`;
        return value;
      });
      csvRows.push(values.join(','));
    });
    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${filename.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const downloadPNG = (chartId) => {
    const chartElement = document.getElementById(chartId);
    if (chartElement) {
      html2canvas(chartElement).then(canvas => {
        const link = document.createElement("a");
        link.download = `${chartId}.png`;
        link.href = canvas.toDataURL();
        link.click();
      });
    }
  };

  return (
    <div 
      id={chartId}
      className={`backdrop-blur-md bg-white/80 border border-slate-100 rounded-2xl shadow-xl p-6 ${className} ${isFullScreen ? 'fixed inset-0 z-50' : ''}`}
    >
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold">{title}</h2>
        <div className="flex items-center gap-2">
          {data && (
            <>
              {/* <button
                onClick={() => downloadCSV(data, title)}
                className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
                title="Download CSV"
              >
                <FileDown size={18} />
              </button>
              <button
                onClick={() => downloadPNG(chartId)}
                className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
                title="Download PNG"
              >
                <Image size={18} />
              </button> */}
            </>
          )}
          {extraActions}
          <button
            onClick={handleFullScreen}
            className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
            title="Toggle Full Screen"
          >
            <Maximize2 size={18} />
          </button>
        </div>
      </div>
      {children}
    </div>
  );
};

export default GlassCard;